"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _ReactHTMLPicture = _interopRequireDefault(require("@micado-digital/react-htmlpicture/ReactHTMLPicture"));

var _ReactSVGIcon = _interopRequireDefault(require("@micado-digital/react-svg-icon/ReactSVGIcon"));

var _Typography = _interopRequireDefault(require("@micado-digital/react-ui/components/Typography"));

var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _de = _interopRequireDefault(require("../locals/de.json"));

var _en = _interopRequireDefault(require("../locals/en.json"));

var _nl = _interopRequireDefault(require("../locals/nl.json"));

var _Author = _interopRequireDefault(require("./Author"));

var _DetectLink = _interopRequireDefault(require("./DetectLink"));

var _ReactSingleTeaser = _interopRequireDefault(require("./ReactSingleTeaser01.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ReactSingleTeaser01 = function ReactSingleTeaser01(_ref) {
  var _clsx;

  var _ref$additionVariant = _ref.additionVariant,
      additionVariant = _ref$additionVariant === void 0 ? "overline" : _ref$additionVariant,
      additionVariants = _ref.additionVariants,
      author = _ref.author,
      _ref$buttonColor = _ref.buttonColor,
      buttonColor = _ref$buttonColor === void 0 ? "primary" : _ref$buttonColor,
      buttonLabel = _ref.buttonLabel,
      _ref$buttonSize = _ref.buttonSize,
      buttonSize = _ref$buttonSize === void 0 ? "medium" : _ref$buttonSize,
      _ref$buttonVariant = _ref.buttonVariant,
      buttonVariant = _ref$buttonVariant === void 0 ? "contained" : _ref$buttonVariant,
      _ref$headlineComponen = _ref.headlineComponent,
      headlineComponent = _ref$headlineComponen === void 0 ? "h2" : _ref$headlineComponen,
      _ref$headlineVariant = _ref.headlineVariant,
      headlineVariant = _ref$headlineVariant === void 0 ? "h4" : _ref$headlineVariant,
      headlineVariants = _ref.headlineVariants,
      icon = _ref.icon,
      iconSize = _ref.iconSize,
      _ref$lang = _ref.lang,
      lang = _ref$lang === void 0 ? "de" : _ref$lang,
      media = _ref.media,
      mediaFormats = _ref.mediaFormats,
      mediaPath = _ref.mediaPath,
      teaser = _ref.teaser,
      _ref$textVariant = _ref.textVariant,
      textVariant = _ref$textVariant === void 0 ? "body1" : _ref$textVariant,
      textVariants = _ref.textVariants,
      variant = _ref.variant;
  var css = (0, _ReactSingleTeaser.default)();
  var l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      nl: _nl.default
    }
  });

  if (!teaser) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }

  var addition = teaser.addition,
      blogDate = teaser.blogDate,
      link = teaser.link,
      linkTarget = teaser.linkTarget,
      text = teaser.text,
      title = teaser.title;
  var size = variant === 2 || variant === 3 ? "small" : "large";
  var alignment = variant === 1 || variant === 3 ? "right" : "left";
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)("mco-singleteaser-01", "mco-singleteaser-01--".concat(alignment), css.root)
  }, /*#__PURE__*/_react.default.createElement(_DetectLink.default, {
    link: link,
    linkTarget: linkTarget
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    className: (0, _clsx2.default)("mco-singleteaser-01__image", (_clsx = {}, _defineProperty(_clsx, css.imageRoot, true), _defineProperty(_clsx, css.imageRootRight, alignment === "right"), _clsx)),
    item: true,
    xs: 12,
    sm: 4,
    md: size === "small" ? 2 : 4
  }, /*#__PURE__*/_react.default.createElement(_ReactHTMLPicture.default, _extends({
    media: media,
    path: mediaPath,
    webpFallback: true
  }, mediaFormats)), blogDate ? /*#__PURE__*/_react.default.createElement(_Chip.default, {
    className: css.chip,
    color: "secondary",
    label: blogDate
  }) : "", author && /*#__PURE__*/_react.default.createElement(_Author.default, {
    data: author
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    className: (0, _clsx2.default)("mco-singleteaser-01__content", css.content),
    item: true,
    xs: 12,
    sm: 8,
    md: size === "small" ? 10 : 8
  }, addition && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx2.default)("mco-singleteaser-01__addition", css.addition),
    component: "p",
    dangerouslySetInnerHTML: {
      __html: addition
    },
    variant: additionVariant,
    variants: additionVariants
  }), title && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx2.default)("mco-singleteaser-01__title", css.title),
    component: headlineComponent,
    dangerouslySetInnerHTML: {
      __html: title
    },
    variant: headlineVariant,
    variants: headlineVariants
  }), text && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx2.default)("mco-singleteaser-01__text", css.text),
    component: "p",
    dangerouslySetInnerHTML: {
      __html: text
    },
    variant: textVariant,
    variants: textVariants
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)("mco-singleteaser-01__button", css.button)
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    color: buttonColor,
    endIcon: icon && /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
      src: icon,
      size: iconSize
    }),
    size: buttonSize,
    variant: buttonVariant
  }, buttonLabel ? buttonLabel : l("reactSingleTeaser01.labels.button")))))));
};

ReactSingleTeaser01.propTypes = {
  additionVariant: _propTypes.default.string,
  additionVariants: _propTypes.default.object,
  author: _propTypes.default.object,
  buttonColor: _propTypes.default.oneOf(["default", "inherit", "primary", "secondary"]),
  buttonLabel: _propTypes.default.string,
  buttonSize: _propTypes.default.oneOf(["small", "medium", "large"]),
  buttonVariant: _propTypes.default.oneOf(["text", "contained", "outlined"]),
  headlineComponent: _propTypes.default.string,
  headlineVariant: _propTypes.default.string,
  headlineVariants: _propTypes.default.object,
  icon: _propTypes.default.string,
  iconSize: _propTypes.default.number,
  lang: _propTypes.default.string,
  media: _propTypes.default.object,
  mediaFormats: _propTypes.default.object,
  mediaPath: _propTypes.default.string,
  teaser: _propTypes.default.object.isRequired,
  textVariant: _propTypes.default.string,
  textVariants: _propTypes.default.object,
  variant: _propTypes.default.number
};
var _default = ReactSingleTeaser01;
exports.default = _default;